var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _rect2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentInconsistent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 107,
    viewBox: "0 0 167 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.1749,
    y: 76.7515,
    width: 101.227,
    height: 10.9499,
    rx: 5.47497,
    fill: "var(--primary-text-color, #313639)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.498 74.2732C153.498 75.6419 152.389 76.7515 151.02 76.7515H113.846C112.477 76.7515 111.368 75.6419 111.368 74.2732V22.2297C111.368 20.861 112.477 19.7515 113.846 19.7515H137.613C138.272 19.7496 138.906 20.011 139.372 20.4776L152.79 33.8949C153.254 34.3596 153.515 34.9898 153.516 35.647L153.498 74.2732Z",
    stroke: "var(--error-color, #f44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.629 19.9751V32.1434C138.629 33.5121 139.738 34.6216 141.107 34.6216H153.275",
    stroke: "var(--error-color, #f44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.017 59.4037H146.072",
    stroke: "var(--error-color, #f44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.72 51.9686H146.072",
    stroke: "var(--error-color, #f44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.64 44.5341H146.075",
    stroke: "var(--error-color, #f44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.017 66.8382H146.072",
    stroke: "var(--error-color, #f44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.498 41.3932H126.133",
    stroke: "var(--error-color, #f44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.498 36.3888H126.133",
    stroke: "var(--error-color, #f44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.061 29.4023C124.301 29.4731 120.48 33.3516 120.48 38.1117C120.48 42.8717 124.301 46.7502 129.061 46.821",
    stroke: "var(--error-color, #f44336)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.1625,
    cy: 50.6497,
    r: 49.9178,
    fill: "var(--error-background-color, #ffefc1)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0302,
    y: 92.4946,
    width: 47.3033,
    height: 14,
    rx: 7,
    fill: "var(--primary-text-color, #313639)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4422 50.6498C93.4422 74.5525 74.0652 93.9295 50.1625 93.9295C26.2597 93.9295 6.88275 74.5525 6.88275 50.6498C6.88275 26.7471 26.2597 7.37012 50.1625 7.37012C74.0652 7.37012 93.4422 26.7471 93.4422 50.6498Z",
    fill: "var(--error-color, #f44336)",
    fillOpacity: 0.35,
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6894 28.1373C73.7087 24.6597 78.5184 32.5274 78.982 34.1169",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8694 55.6213C58.6351 54.8355 55.967 57.1114 55.7237 57.714",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1645 22.6705C37.1452 19.1929 32.3356 27.0606 31.872 28.6501",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4001 37.7256C41.5673 37.7256 41.7308 37.7752 41.8699 37.8681C42.0089 37.961 42.1173 38.093 42.1813 38.2475C42.2453 38.402 42.262 38.5721 42.2294 38.7361C42.1968 38.9001 42.1162 39.0508 41.998 39.169C41.8797 39.2873 41.7291 39.3678 41.5651 39.4004C41.4011 39.433 41.231 39.4163 41.0765 39.3523C40.922 39.2883 40.79 39.1799 40.6971 39.0409C40.6042 38.9018 40.5546 38.7384 40.5546 38.5711C40.5546 38.3469 40.6437 38.1318 40.8022 37.9732C40.9608 37.8147 41.1759 37.7256 41.4001 37.7256Z",
    fill: "var(--primary-text-color, #313639)",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1709 37.7256C70.3382 37.7256 70.5016 37.7752 70.6407 37.8681C70.7797 37.961 70.8881 38.093 70.9521 38.2475C71.0161 38.402 71.0328 38.5721 71.0002 38.7361C70.9676 38.9001 70.8871 39.0508 70.7688 39.169C70.6506 39.2873 70.4999 39.3678 70.3359 39.4004C70.1719 39.433 70.0019 39.4163 69.8474 39.3523C69.6929 39.2883 69.5608 39.1799 69.4679 39.0409C69.375 38.9018 69.3254 38.7384 69.3254 38.5711C69.3254 38.3469 69.4145 38.1318 69.573 37.9732C69.7316 37.8147 69.9467 37.7256 70.1709 37.7256Z",
    fill: "var(--primary-text-color, #313639)",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3591 77.5401L54.9121 71.6855L60.4239 70.8597C60.9666 70.8296 61.4752 70.5852 61.8377 70.1802C62.2002 69.7752 62.3869 69.2427 62.3569 68.7C62.3268 68.1573 62.0824 67.6488 61.6774 67.2863C61.2723 66.9238 60.7399 66.737 60.1972 66.7671L44.3579 67.2836C44.3579 67.2836 45.1824 58.7907 42.4163 58.7907C39.6503 58.7906 39.6761 61.9381 38.606 67.36L27.9976 76.1988",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0868,
    y: 43.9014,
    width: 14.2617,
    height: 12.0315,
    rx: 6.01576,
    fill: "white",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.3333,
    y: 43.9014,
    width: 14.2617,
    height: 12.0315,
    rx: 6.01576,
    fill: "white",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentInconsistent);
export default __webpack_public_path__ + "static/media/payment_inconsistent.d6831822.svg";
export { ForwardRef as ReactComponent };